<template>
<div class="chapter">
<div class="inner_page">
<p class="C108"><a id="page_xvi">SO CONCEIVED AND SO DEDICATED</a></p><a id="page_xvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Halftitle_Page_1.vue?082eb870